function pairCoachingScreen() {
    var pairingCode = window.location.search.replace('?','') || null;
    window.location = `https://portal.hub.gymsystems.co/device-management?pair=${pairingCode}&device=screen`;
}

function pairCCTV() {
    var pairingCode = window.location.search.replace('?','') || null;
    window.location = `https://portal.hub.gymsystems.co/device-management?pair=${pairingCode}&device=camera`;
}

function pairDuress() {
    var pairingCode = window.location.search.replace('?','') || null;
    window.location = `https://portal.hub.gymsystems.co/device-management?pair=${pairingCode}&device=duress`;
}


export { 
    pairCoachingScreen,
    pairCCTV,
    pairDuress
}
